export default __webpack_public_path__ + "static/media/495px-Light_dispersion_conceptual_waves.4218b0a0.gif";